module.exports = __webpack_public_path__ + "static/img/dorm.d70928c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dorm.png
// module id = 8rUf
// module chunks = 58